import { StyleObject } from "styletron-react";
import { COLORS } from "../../shared";

export const styledWhiteHeadline: StyleObject = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "8px",
  background: COLORS.gray50,
};
